var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Android-sunny SVG Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 160c25.499 0 49.567 10.025 67.771 28.229S352 230.501 352 256s-10.025 49.567-28.229 67.771S281.499 352 256 352s-49.567-10.025-67.771-28.229S160 281.499 160 256s10.025-49.567 28.229-67.771S230.501 160 256 160m21.333-128h-42.666v64h42.666V32zm129.063 43.729L368 114.135 397.864 144l38.406-38.396-29.874-29.875zm-300.792 0l-29.875 29.875L114.136 144 144 114.135l-38.396-38.406zM256 128c-70.396 0-128 57.604-128 128s57.604 128 128 128 128-57.604 128-128-57.604-128-128-128zm224 106.666h-64v42.668h64v-42.668zm-384 0H32v42.668h64v-42.668zM397.864 368L368 397.865l38.396 38.406 29.875-29.875L397.864 368zm-283.728 0L75.73 406.396l29.875 29.875L144 397.865 114.136 368zm163.197 48h-42.666v64h42.666v-64z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.b515d703b754c10b582e56e17283985c.svg";
export { ForwardRef as ReactComponent };